// extracted by mini-css-extract-plugin
export default {"container":"HeaderMenuLinks_container__GF0sZ"};